/** Fixed white border padding as a fraction of resized width/height on each side. */
export const FLOOR_PLAN_3D_PADDING_RATIO = 0.3;

/**
 * @param {string} [_cameraView]
 * @returns {number}
 */
export function resolveFloorPlan3dPaddingRatio(_cameraView) {
  return FLOOR_PLAN_3D_PADDING_RATIO;
}
